import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n\n    ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    outline: none;\n    border-width: 1px;\n    border-style: solid;\n    border-radius: ", ";\n    font-family: ", ";\n    text-decoration: none;\n    white-space: nowrap;\n    cursor: pointer;\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n              visibility: hidden;\n          "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n                border-color: ", ";\n                font-weight: ", ";\n                background-color: ", ";\n\n                &,\n                &:hover,\n                &:focus,\n                &:active {\n                    color: ", ";\n                }\n\n                &:hover,\n                &:focus {\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n\n                &:active {\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n            "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n                border-color: ", ";\n                color: ", ";\n                background-color: ", ";\n\n                &:hover,\n                &:focus {\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n\n                &:active {\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n            "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n                padding: 0;\n                border-color: transparent;\n                color: ", ";\n                background-color: transparent;\n\n                &:hover,\n                &:focus {\n                    color: ", ";\n                    text-decoration: underline;\n                }\n\n                &:active {\n                    color: ", ";\n                    text-decoration: underline;\n                }\n            "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n                    width: ", "px;\n                "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n                padding: 0 ", "px;\n                ", ";\n                height: ", "px;\n            "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n                    width: ", "px;\n                "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n                border-radius: ", ";\n                padding: 0 ", "px;\n                ", ";\n                height: ", "px;\n                ", ";\n                font-weight: ", ";\n                letter-spacing: ", ";\n            "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n                    width: ", "px;\n                "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n                padding: 0 ", "px;\n                ", ";\n                height: ", "px;\n                ", ";\n                font-weight: ", ";\n            "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n              border-radius: 50%;\n              padding: 0;\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n              width: 100%;\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        &,\n        &:hover,\n        &:focus {\n            border: 2px solid ", ";\n            color: ", ";\n            background-color: ", ";\n            cursor: default;\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            &,\n            &:hover,\n            &:focus {\n                border-color: transparent;\n                color: ", ";\n                text-decoration: none;\n                background-color: transparent;\n                cursor: default;\n            }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { Loader } from '../Loader';
import { transitions, typography } from '../mixins';

function disabled(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      variant = _ref.variant;

  if (!disabled) {
    return null;
  }

  if (variant === 'text') {
    return css(_templateObject(), theme.palette.gray.gray200);
  }

  return css(_templateObject2(), theme.palette.gray.gray200, theme.palette.gray.gray200, theme.palette.common.white);
}

function fullWidth(_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth ? css(_templateObject3()) : null;
}

function rounded(_ref3) {
  var rounded = _ref3.rounded;
  return rounded ? css(_templateObject4()) : null;
}

function size(_ref4) {
  var theme = _ref4.theme,
      size = _ref4.size,
      rounded = _ref4.rounded;

  switch (size) {
    case 'small':
      {
        return css(_templateObject5(), theme.unit * 2 - 3, rounded && css(_templateObject6(), theme.unit * 4 + 2), theme.unit * 4 + 2, typography('body3'), theme.typography.action.fontWeight);
      }

    case 'large':
      {
        return css(_templateObject7(), theme.shape.borderRadius.large, theme.unit * 3, rounded && css(_templateObject8(), theme.unit * 8 + 4), theme.unit * 8 + 4, typography('body1'), theme.typography.action.fontWeight, theme.typography.action.letterSpacing);
      }

    default:
      {
        return css(_templateObject9(), theme.unit * 3, rounded && css(_templateObject10(), theme.unit * 6), theme.unit * 6);
      }
  }
}

function variant(_ref5) {
  var theme = _ref5.theme,
      _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? 'primary' : _ref5$color,
      variant = _ref5.variant;
  var palette = theme.palette,
      typography = theme.typography;
  var _palette$color = palette[color],
      main = _palette$color.main,
      hover = _palette$color.hover,
      active = _palette$color.active;

  switch (variant) {
    case 'text':
      {
        return css(_templateObject11(), main, hover, active);
      }

    case 'outlined':
      {
        return css(_templateObject12(), palette.gray.gray300, palette.text.primary, palette.common.white, palette.gray.gray400, palette.gray.gray100, palette.gray.gray400, palette.gray.gray400);
      }

    default:
      {
        return css(_templateObject13(), main, typography.action.fontWeight, main, palette.primary.contrastText, hover, hover, active, active);
      }
  }
}

function hideWhileLoading(_ref6) {
  var working = _ref6.working;
  return working ? css(_templateObject14()) : null;
}

var StyledButton = styled.button(_templateObject15(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.shape.borderRadius.medium;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.fontFamily;
}, size, variant, fullWidth, rounded, disabled, transitions(['border-color', 'color', 'background-color']).easeOut().shortest());
var Content = styled.div(_templateObject16(), hideWhileLoading);
var LoadingIndicator = styled(Loader)(_templateObject17());
export var Button = forwardRef(function (_a, ref) {
  var _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$working = _a.working,
      working = _a$working === void 0 ? false : _a$working,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'medium' : _a$size,
      _a$color = _a.color,
      color = _a$color === void 0 ? 'primary' : _a$color,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'filled' : _a$variant,
      _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? false : _a$fullWidth,
      _a$rounded = _a.rounded,
      rounded = _a$rounded === void 0 ? false : _a$rounded,
      component = _a.component,
      children = _a.children,
      onClick = _a.onClick,
      other = __rest(_a, ["disabled", "working", "size", "color", "variant", "fullWidth", "rounded", "component", "children", "onClick"]);

  var props = Object.assign(Object.assign({}, other), {
    ref: ref,
    size: size,
    color: color,
    variant: variant,
    fullWidth: fullWidth,
    rounded: rounded,
    disabled: disabled
  });
  var handleClick = useCallback(function (event) {
    if (disabled || working) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (typeof onClick === 'function') {
      onClick(event);
    }
  }, [onClick, disabled, working]);
  return React.createElement(StyledButton, Object.assign({}, props, {
    onClick: handleClick
  }, component && {
    as: component
  }), children && React.createElement(Content, {
    working: working
  }, children), working && React.createElement(LoadingIndicator, null));
});
Button.displayName = 'Button';